import React from "react";
import "./spinner.css";

export const LoadingSpinner = ({ overlay = false, text = "Loading..." }) => {
    const content = (
      <div className="spinner-container">
        <div className="loading-spinner"></div>
        <span className="spinner-text">{text}</span>
      </div>
    );

    if (overlay) {
      return (
        <div className="spinner-overlay">
          {content}
        </div>
      );
    }

    return content;
  }